<script>
import Footer from "@/components/Footer";

export default {
  components: {
    Footer,
  },
};
</script>

<template>
  <div class="Outer">
    <div class="Inner">
      <slot />
    </div>
    <Footer />
  </div>
</template>

<style scoped>
.Outer {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.Inner {
  flex: 1;
}
</style>
